// GÉNÉRÉ par `pnpm blueprint apply` à partir de blueprint.json — ne pas modifier à la main.
import type { WebModule } from "../core/modules";
import tenants from "./tenants/index";
import crm from "./crm/index";
import guides from "./guides/index";

export const MODULES: WebModule[] = [tenants, crm, guides];
